export default __webpack_public_path__ + "230f2c6.png";